var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "loading"
    ? _c("span", { staticClass: "sui-animation-rotate" }, [
        _c("img", {
          staticStyle: { "vertical-align": "middle" },
          attrs: {
            src: require("@/style/img/loading-grey.png"),
            width: "28",
            height: "28",
            alt: ""
          }
        })
      ])
    : _c("span", {
        staticClass: "sui-iconfont",
        class: _vm.iconClass,
        style: { color: _vm.color, "font-size": _vm.size }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }